import React from 'react';
// import { theme } from 'antd'
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import CardPackage from './card_package';
import { comparisonTableStyle, ComparisonTableColumns } from './comparisonTableLayout';
import { formatCoverageValue } from 'Utils';
import { formatDateForDisplay } from '@shared/utils/dateUtils';
import './index.css';

const TablePackages = (props) => {
  const { insuranceCarriers, packages } = props;

  // const { token: themeToken } = theme.useToken();

  // const [state, setState] = useState(false);
  // const ref = useRef(null);
  // const handleScroll = () => {
  //   setState(window.scrollY > ref.current.getBoundingClientRect().top);
  // };

  // useEffect(() => {
  //   window.addEventListener('scroll', handleScroll);
  //   return () => {
  //     window.removeEventListener('scroll', handleScroll);
  //   };
  // });

  return (
    <div
      className='table-packages-container'
      // style={{
      //   background: themeToken.colorBgLayout,
      // }}
    >
      {/* <div className={`${state ? 'scrolleable' : ''}`}> </div> */}
      {/* <div ref={ref} className={state ? 'scroll' : ''}> */}
      <table className="table-packages" style={comparisonTableStyle(packages.length)}>
        <ComparisonTableColumns planCount={packages.length} packages={packages} />
        <tbody>
          <tr>
            <td></td>
            {
              packages.map((pack) => {
                return (
                  <td key={pack.id}  style={{textAlign:'center'}}>
                    <CardPackage
                      packageItem={pack}
                      insuranceCarrier={insuranceCarriers.find((insurance) => insurance.id === pack.insurance_carrier)}
                    />
                  </td>
                );
              })
            }
          </tr>
          <tr>
            <td>Cotización</td>
              {
                packages.map((pack) => {
                  return (
                    <td key={pack.id}  style={{textAlign:'center'}}>
                      <div style={{ marginBottom: '10px', display: 'inline-block', color: '#5f5f5f' }}>#{pack.number}</div>
                    </td>
                  );
                })
              }
            
          </tr>
          <tr>
            <td>Fecha de cotización</td>
            {packages.map((pack) => (
              <td key={pack.id} style={{ textAlign: 'center' }}>
                <div>{formatDateForDisplay(pack.created_at)}</div>
              </td>
            ))}
          </tr>
          <tr>
            <td>Fecha de vigencia</td>
            {packages.map((pack) => (
              <td key={pack.id} style={{ textAlign: 'center' }}>
                <div>{formatDateForDisplay(pack.expiration_date)}</div>
              </td>
            ))}
          </tr>
          <tr>
            <td>Plan</td>
            {
                packages.map((pack) => {
                  return (
                    <td key={pack.id} style={{textAlign:'center'}}>
                      <div>
                        <span className="name-package">{pack.package_detail}</span>
                      </div>
                    </td>
                  );
                })
              }
          </tr>
          <tr>
            <td>Valor prima</td>
            {
                packages.map((pack) => {
                  const payment = pack.payments.find((paymentIterator) => paymentIterator.id === 'ANUAL');
                  return (
                    <td key={pack.id} style={{textAlign:'center'}}>
                        <div>
                          <span className="payment-text">pago contado</span>
                          <span className="payment-value">&nbsp;{formatCoverageValue(payment.value)}</span>
                        </div>
                    </td>
                  );
                })
              }
          </tr>
        </tbody>
      </table>
      {/* </div> */}
    </div>
  );
};

TablePackages.propTypes = {
  insuranceCarriers: PropTypes.array.isRequired,
  packages: PropTypes.array.isRequired,
};

const mapStateToProps = (state) => ({ insuranceCarriers: state.initialData.aseguradoras });

export default connect(mapStateToProps, {})(TablePackages);
